import Link from 'next/link';
import styles from './index.module.scss';
import Icon1 from './icons/Icon1';
import Icon2 from './icons/icon2';
import Icon3 from './icons/icon3';
import { useLang } from '@/app/utils/useLang';

const Choose: React.FC = () => {
    const { t } = useLang('choose');
    const items = [
        {
            icon: Icon1,
            label: t('item1_label'),
            desc: t('item1_desc'),
        },
        {
            icon: Icon2,
            label: t('item2_label'),
            desc: t('item2_desc'),
        },
        {
            icon: Icon3,
            label: t('item3_label'),
            desc: t('item3_desc'),
        },
    ];
    return (
        <div className={styles.Choose}>
            <div>
                <div className="title">{t('title')}</div>
                <div className="wrapper">
                    {items.map((item) => {
                        return (
                            <div key={item.label} className="wrapper-item">
                                <item.icon className="icon-wrapper" />
                                <div className="text-box">
                                    <div className="label">{item.label}</div>
                                    {item.desc.startsWith('http') ? (
                                        <Link className="desc link" href={item.desc} target="_blank">
                                            {t('link_text')}
                                        </Link>
                                    ) : (
                                        <div className="desc">{item.desc}</div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Choose;
